import React, { useReducer } from 'react'
import { UserRegistrationFormDataReducer, userRegistrationFormDataInitialState } from './UserRegistrationFormDataReducer';
import { UserRegistrationFormValidationReducer, userRegistrationFormValidationInitialState } from './UserRegistrationFormValidationReducer';
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { Row, Col, Alert, Spinner } from 'react-bootstrap';
import { validateInput } from "./UserRegistrationValidationService";
import CountrySelect from 'uiwidgets/CountrySelect';
import ProvinceSelect from 'uiwidgets/ProvinceSelect';
import { kickOffFullFormValidation } from 'util/Validators';
import { CancelButton } from 'uiwidgets/CancelButton';
import PageContentContainer from 'uiwidgets/PageContentContainer';
import PostalCode from 'uiwidgets/PostalCode';
import { PasswordField } from 'uiwidgets/PasswordField';


function UserRegistrationPage(props) {

  const [formData, formDispatch] = useReducer(UserRegistrationFormDataReducer, userRegistrationFormDataInitialState);
  const [formValidityData, formValidityDispatch] = useReducer(UserRegistrationFormValidationReducer, userRegistrationFormValidationInitialState)

  const onToastClose = () => {
    formDispatch({ type: 'CLEAR_INFO_AND_ERROR' });
  }

  const handleChange = (event) => {
    if (false) {
      return;
    }
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formDispatch({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
  }

  const handleCountryChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    let defaultState = "ON";
    if (value === "US") {
      defaultState = "MI";
    }
    formDispatch({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
    formDispatch({ type: 'FIELD_EDIT', payload: { name: "state", value: defaultState } })
  }

  const handleValidation = (event) => {
    if (false) {
      return;
    }
    let dispatchType = 'VALIDATE_' + event.target.name.toUpperCase();
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formValidityDispatch({ type: dispatchType, payload: { [name]: value, formData: formData } })
  }

  const handleCancel = (event) => {
    formDispatch({ type: "FORM_CANCEL" });
  }

  const userRegistrationSuccessHandler = (data) => {
    formDispatch({ type: 'FORM_SUBMIT_SUCCESS', payload: data });
  };

  const userRegistrationFailureHandler = (data) => {
    formDispatch({ type: 'FORM_SUBMIT_FAIL', payload: data });
  };


  const handleSubmit = (event) => {
    event.preventDefault();
    let formDataEvent = {
      ...event,
      formData: formData,
      formDataIsIsolated: false
    }
    let isFormValid = kickOffFullFormValidation(formDataEvent, formValidityDispatch, validateInput);
    if (!isFormValid) {
      alert("The form still has validation errors!");
      return false;
    }
    formDispatch({
      type: 'FORM_SUBMIT', payload: {
        formData: formData,
        successFunction: userRegistrationSuccessHandler,
        failureFunction: userRegistrationFailureHandler
      }
    });
  }

  return (
    <>
      {formData.status && <PageContentContainer><Alert key="info" variant='info'>
        <Spinner animation="border" role="status" variant='dark' className="me-4" />
        {formData.status}
      </Alert></PageContentContainer>}
      <FormContainer title="User Registration" submitButtonFunction={handleSubmit}
        errors={formData.errors} infoMessage={formData.infoMessage} toastCloseFunc={onToastClose}
        className="profile-form">

        <Row className="userRegistration">
          <Col mb={5} lg={5} sm={6}>
            <FormField name="userName" label="User Name" type="text" value={formData.userName}
              placeholder="User Name" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.userNameError} valMsg={formValidityData.userNameErrMsg}
              readOnly={formData.readOnly} />
          </Col>
          <Col mb={7} lg={7} sm={6}>
            <PasswordField name="password" label="Password" value={formData.password}
              placeholder="Password" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.passwordError} valMsg={formValidityData.passwordErrMsg} 
              readOnly={formData.readOnly}/>

          </Col>
        </Row>
        <Row>
          <Col mb={5} lg={5} sm={6}>
            <FormField name="firstName" label="First Name" type="text" value={formData.firstName}
              placeholder="First Name" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.firstNameError} valMsg={formValidityData.firstNameErrMsg}
              readOnly={formData.readOnly} />
          </Col>
          <Col mb={7} lg={7} sm={6}>
            <FormField name="lastName" label="Last Name" type="text" value={formData.lastName}
              placeholder="Last Name" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.lastNameError} valMsg={formValidityData.lastNameErrMsg}
              readOnly={formData.readOnly} />
          </Col>
        </Row>
        <Row>
          <Col mb={7} lg={7} sm={6}>
            <FormField name="companyName" label="Company Name" type="text" value={formData.companyName}
              placeholder="Company Name" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.companyNameError} valMsg={formValidityData.companyNameErrMsg}
              readOnly={formData.readOnly} />
          </Col>
        </Row>
        <Row>
          <Col mb={12} lg={12} sm={12}>
            <FormField name="address" label="Address" type="text" value={formData.address}
              placeholder="Address" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.addressError} valMsg={formValidityData.addressErrMsg}
              readOnly={formData.readOnly} />

          </Col>
        </Row>
        <Row>
          <Col mb={2} lg={2} sm={6}>
            <CountrySelect name="country" onChange={handleCountryChange} onBlur={handleValidation}
              valstate={!formValidityData.countryError} valMsg={formValidityData.countryErrMsg}
              readOnly={formData.readOnly} value={formData.country} />
          </Col>
          <Col mb={4} lg={4} sm={12}>
            <ProvinceSelect name="state" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.stateError} valMsg={formValidityData.stateErrMsg}
              readOnly={formData.readOnly} value={formData.state} country={formData.country} />
          </Col>
        </Row>
        <Row>
          <Col mb={4} lg={4} sm={12}>
            <FormField name="city" label="City" type="text" value={formData.city}
              placeholder="City" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.cityError} valMsg={formValidityData.cityErrMsg}
              readOnly={formData.readOnly} />
          </Col>
          <Col mb={4} lg={4} sm={12}>
            <PostalCode name="zip" label="Postal Code" type="text" value={formData.zip}
              placeholder="Postal Code" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.zipError} valMsg={formValidityData.zipErrMsg}
              readOnly={formData.readOnly} country={formData.country}/>
          </Col>
        </Row>
        <Row>
          <Col mb={6} lg={6} sm={12}>
            <FormField name="mobilePhoneNumber" label="Mobile Phone Number" type="text" value={formData.mobilePhoneNumber}
              placeholder="Mobile Phone Number" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.mobilePhoneNumberError} valMsg={formValidityData.mobilePhoneNumberErrMsg}
              readOnly={formData.readOnly} />
          </Col>
          <Col mb={6} lg={6} sm={6}>
            <FormField name="officePhoneNumber" label="Office Phone Number" type="text" value={formData.officePhoneNumber}
              placeholder="Office Phone Number" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.officePhoneNumberError} valMsg={formValidityData.officePhoneNumberErrMsg}
              readOnly={formData.readOnly} />
          </Col>
        </Row>
        <Row>
          <Col mb={12} lg={12} sm={12}>
            <FormField name="email" label="Email" type="text" value={formData.email}
              placeholder="Email" onChange={handleChange} onBlur={handleValidation}
              valstate={!formValidityData.emailError} valMsg={formValidityData.emailErrMsg}
              readOnly={formData.readOnly} />
          </Col>
        </Row>
        <Row>
          <Col>
            <SubmitButton label='Save UserRegistration' className="me-4" />
            <CancelButton label='Cancel Edits' disabled={formData.readOnly} onClick={handleCancel} />

          </Col>
        </Row>
      </FormContainer>
    </>
  )
}

export default UserRegistrationPage;
